import React from 'react'
import {
  List as ListIcon,
  Map,
  Activity
} from 'react-feather'
import { useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { TabItem } from '../../../components'

const ListNav = ({fromOrganization, embed, activeTab, onChange, handleStatistic, handleMap}) => {
  const translation = useSelector(state => state.translation.data)
  const language = useSelector(state => state.system.language)
  const history = useHistory()
  const mobilePadding = embed ? 'pt-2 px-3 pb-2' : 'pt-5 px-5 pb-3'
  const location = useLocation()
  const { isOfficial, isLoggedIn } = useSelector(state => state.account)

  const handleStatisticLink = () => {
    if (fromOrganization) {
      // history.push('/program-statistic-organization')
      handleStatistic(translation.VIEW.statistic[language.name])
    } else {
      history.push({
        pathname: '/program-statistic',
        search: location.search
      })
    }
  }

  const handleMapLink = () => {
    if (fromOrganization) {
      handleMap(translation.VIEW.statistic[language.name])
    } else {
      history.push({
        pathname: '/program-map',
        search: location.search
      })
    }
  }

  return (
    <div className="flex border-b mb-5 lg:mb-8">
      <TabItem
        selected={activeTab}
        onClick={onChange}
        text={translation.VIEW.list[language.name]}
        icon={<ListIcon style={{width: '20px'}}/>}
        className={`${mobilePadding} lg:pt-0 lg:px-0 lg:pb-4 lg:pr-1`}
        accent={embed ? false : true}
        uppercase={embed ? false : true}
        embed
      />
      {
        fromOrganization ? (
          isOfficial ?
          <TabItem
            selected={activeTab}
            onClick={handleStatisticLink}
            text={translation.VIEW.statistic[language.name]}
            icon={<Activity style={{width: '20px'}}/>}
            className={`${mobilePadding} lg:pt-0 lg:px-0 lg:pb-4 lg:pr-1 lg:ml-12`}
            accent={embed ? false : true}
            uppercase={embed ? false : true}
            embed
          /> : <></>
        ) : (
          <TabItem
            selected={activeTab}
            onClick={
              () => {
                if (isLoggedIn) {
                  handleStatisticLink()
                } else {
                  history.push('/login')
                }
              }
            }
            text={translation.VIEW.statistic[language.name]}
            icon={<Activity style={{width: '20px'}}/>}
            className={`${mobilePadding} lg:pt-0 lg:px-0 lg:pb-4 lg:pr-1 lg:ml-12`}
            accent={embed ? false : true}
            uppercase={embed ? false : true}
            embed
          />
        )
      }
      <TabItem
        selected={activeTab}
        onClick={() => {
          if (isLoggedIn) {
            handleMapLink()
          } else {
            history.push('/login')
          }
        }}
        text={translation.VIEW.map[language.name]}
        icon={<Map style={{width: '20px'}}/>}
        className={`${mobilePadding} lg:pt-0 lg:px-0 lg:pb-4 lg:pr-1 lg:ml-12`}
        accent={embed ? false : true}
        uppercase={embed ? false : true}
        embed
      />
    </div>
  )
}

export { ListNav }
